import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>'
})
export class App implements OnInit {
  protected readonly title = signal('sim-issue-tracker-front');

  private readonly msal = inject(MsalService);

  ngOnInit(): void {
    this.msal.handleRedirectObservable().subscribe();
  }
}
